import { User } from '../types/tournament';

export const imgOptionUserLabel = (user: User) => ({
    value: user.id,
    label: user.firstName && user.lastName ? user.firstName + ' ' + user.lastName : user.userName,
    avatar: user.avatar,
});
